import { render } from "./ListePrixProduitCondTypeClientPage.vue?vue&type=template&id=f667e7c2&ts=true"
import script from "./ListePrixProduitCondTypeClientPage.vue?vue&type=script&lang=ts"
export * from "./ListePrixProduitCondTypeClientPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__